import { render, staticRenderFns } from "./DemandeReinscriptionPsychologue.vue?vue&type=template&id=436adce1"
import script from "./DemandeReinscriptionPsychologue.vue?vue&type=script&lang=js"
export * from "./DemandeReinscriptionPsychologue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports